const enumManager = {
	getUserTypesStr(obj) {
		let str = '';
		try {
			for (let i = 0; i < obj.length; i++) {
				switch (obj[i].type) {
					case 1:
						str += '资讯管理 ';
						break;
					case 2:
						str += '业务管理 ';
						break;
					case 3:
						str += '招聘管理 ';
						break;
					case 4:
						str += '用户管理 ';
						break;
				}
			}
		} catch (err) {}

		return str;
	}
}
export default enumManager;



// WEBPACK FOOTER //
// ./src/utils/enumManager.js